import i18n from "i18next";
import * as React from "react";
import { BaseAPI, Configuration } from "../api";

import { useRouter } from "./useRouter";
import { ERoutes } from "../AppRouter";
import { useAuth } from "../contexts/AuthContext";

export let baseUrl =
  (document.getElementById("_baseUrl") as HTMLInputElement)?.value || "~";

if (baseUrl === "~") {
  const hostUrl = window.location.href.split("/");
  baseUrl = hostUrl[0] + "//" + hostUrl[2];
}

export function useApiService<T extends BaseAPI>(
  type: new (configuration: Configuration) => T,
  transformRequest?: (request: RequestInit) => RequestInit
): T {
  const router = useRouter();
  const { getAccessToken } = useAuth();

  const getAccessTokenPromise = React.useCallback(async () => {
    return await getAccessToken();
  }, [getAccessToken]);

  const configuration = React.useMemo(() => {
    const cfg: Configuration = {
      basePath: baseUrl,
      headers: {
        "Accept-Language": i18n.language,
      },
      apiKeyPromise: getAccessTokenPromise,
      middlewares: [
        {
          pre(request) {
            const result = transformRequest
              ? transformRequest(request)
              : request;
            return Promise.resolve(result);
          },
          post(response) {
            if (response.status === 401 || response.status === 403) {
              router.replace(ERoutes.unauthorized);
            }
            return Promise.resolve(response);
          },
        },
      ],
    };

    return cfg;
  }, [getAccessTokenPromise, transformRequest, router]);
  return React.useMemo(() => new type(configuration), [configuration, type]);
}
